import {
    IconButton,
    StyleFunction,
    Text,
    useThemedStyle,
} from "@venuepos/react-common";
import { ProductSectionButton } from "lib";
import React from "react";
import { StyleProp, TextStyle, View, ViewStyle } from "react-native";

export const LayoutButtonComponent = React.memo(
    ({
        button,
        label,
        formattedAmount,
        showWarning,
        onPress,
        onDelete,
        onSendTo,
        textStyle,
        buttonStyle,
        testID,
    }: {
        button: ProductSectionButton;
        label: string;
        formattedAmount?: string | null;
        showWarning?: boolean;
        onPress: () => void;
        onDelete: () => void;
        onSendTo: () => void;
        textStyle: StyleProp<TextStyle>;
        buttonStyle: StyleProp<ViewStyle>;
        testID?: string;
    }) => {
        const styles = useThemedStyle(styleFunc);

        return (
            <View
                style={[styles.buttonStyle, buttonStyle]}
                testID={`layout:button:${button.buttonType}`}
            >
                <View
                    style={[
                        styles.helperContainer,
                        showWarning ? styles.warning : null,
                    ]}
                >
                    <View style={styles.helperContainerLeft}>
                        <IconButton
                            name="settings"
                            size="small"
                            onPress={onPress}
                            testID="settings"
                        />
                        <IconButton
                            name="send-to"
                            size="small"
                            onPress={onSendTo}
                            testID="sendTo"
                        />
                    </View>
                    <View style={styles.helperContainerRight}>
                        <IconButton
                            name="delete"
                            size="small"
                            onPress={onDelete}
                            testID="delete"
                        />
                    </View>
                </View>
                <View
                    style={[
                        styles.contentContainer,
                        showWarning ? styles.warningContainer : null,
                    ]}
                >
                    <Text
                        style={[styles.buttonLabel, textStyle]}
                        testID={testID}
                        numberOfLines={2}
                    >
                        {label}
                    </Text>
                    {formattedAmount ? (
                        <Text
                            style={[
                                styles.buttonLabel,
                                textStyle,
                                styles.productAmount,
                            ]}
                            numberOfLines={1}
                        >
                            {formattedAmount}
                        </Text>
                    ) : null}
                </View>
            </View>
        );
    },
    (newProps, oldProps) => newProps.button === oldProps.button
);

const styleFunc: StyleFunction = theme => ({
    buttonStyle: {
        borderRadius: theme.borderRadiusTiny,
    },
    buttonLabel: {
        ...theme.fonts.medium,
        fontSize: 16,
        textAlign: "center",
    },
    productAmount: {
        ...theme.fonts.regular,
    },
    contentContainer: {
        flex: 1,
        justifyContent: "center",
        padding: theme.spacingScale,
        userSelect: "none",
        borderWidth: 1,
        borderColor: theme.colors.semiTransparentBlack,
        borderTopWidth: 0,
        borderBottomRightRadius: theme.borderRadiusTiny,
        borderBottomLeftRadius: theme.borderRadiusTiny,
    },
    helperContainer: {
        flexDirection: "row",
        backgroundColor: theme.colors.semiTransparentBlack,
        borderTopStartRadius: theme.borderRadiusTiny,
        borderTopEndRadius: theme.borderRadiusTiny,
    },
    helperContainerLeft: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "flex-start",
    },
    helperContainerRight: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "flex-end",
        borderTopEndRadius: theme.borderRadiusTiny,
    },

    warning: {
        backgroundColor: theme.colors.error,
    },
    warningContainer: {
        borderColor: theme.colors.error,
        borderWidth: theme.borderWidth * 3,
    },
});
